import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faBullseye, faHeart, faHandshake, faBolt, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';
import {CardFrame, CardGrid, CardContent} from '../../components/ui/card';

const MissionVision = () => {
  const { t } = useTranslation();
  const titleRef = useScrollReveal();
  const missionRef = useScrollReveal();
  const visionRef = useScrollReveal();
  const valuesRef = useScrollReveal();

  const coreValues = [
    { icon: faShieldAlt, key: 'transparency', label: t('about.values.transparency'), desc: t('about.values.transparencyDesc') },
    { icon: faHeart, key: 'trust', label: t('about.values.trust'), desc: t('about.values.trustDesc') },
    { icon: faBolt, key: 'speed', label: t('about.values.speed'), desc: t('about.values.speedDesc') },
    { icon: faHandshake, key: 'collaboration', label: t('about.values.collaboration'), desc: t('about.values.collaborationDesc') },
  ];

  return (
    <section className="mission-vision">
      <div className="container">
        {/* mission-vision-grid 대체 */}
        <CardGrid min="300px" gap="2rem">
          <CardFrame
            ref={missionRef}
            className="scroll-reveal mv-card-content"
            padding="2rem"
            radius="15px"
            shadow="normal"
            hover="lg"
          >
            <CardContent
              variant="mv"
              icon={<FontAwesomeIcon icon={faBullseye} />}
              title={<h3>{t('about.mission.title')}</h3>}
              desc={<p>{t('about.mission.text')}</p>}
            />
          </CardFrame>

          <CardFrame
            ref={visionRef}
            className="scroll-reveal mv-card-content"
            padding="2rem"
            radius="15px"
            shadow="normal"
            hover="lg"
          >
            <CardContent
              variant="mv"
              icon={<FontAwesomeIcon icon={faEye} />}
              title={<h3>{t('about.vision.title')}</h3>}
              desc={<p>{t('about.vision.text')}</p>}
            />
          </CardFrame>
        </CardGrid>

        <h2 ref={titleRef} className="section-title scroll-reveal" style={{ marginTop: '4rem' }}>
          {t('about.values.title')}
        </h2>

        {/* values-grid 대체 */}
        <div ref={valuesRef} className="scroll-reveal">
          <CardGrid min="250px" gap="2rem">
            {coreValues.map((value) => (
              <CardFrame
                key={value.key}
                className="value-card-content"
                padding="2rem"
                radius="10px"
                shadow="soft"
                hover="md"
              >
                <CardContent
                  variant="value"
                  icon={<FontAwesomeIcon icon={value.icon} />}
                  title={<h4>{value.label}</h4>}
                  desc={<p>{value.desc}</p>}
                />
              </CardFrame>
            ))}
          </CardGrid>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
